import { Injectable } from '@angular/core';
import { VisibaApiHttp } from '../../../Classes/visibaHttp.class';
import { CallSettingsApiModel } from './Models/CallSettingsApiModel';
import { SpaContext } from '../../../Classes/spacontext';

@Injectable()
export class LicenceHolderServiceV2 {
	baseUri: string = '';

	constructor(public http: VisibaApiHttp, public spaContext: SpaContext) {
		this.baseUri = `/api/Client/v2/${this.spaContext.unitConfig.LicenceHolder.Id}`;
	}

	getCallSettings() {
		return this.http.getTyped<CallSettingsApiModel>(this.baseUri + '/CallSettings');
	}
}
